import { FundingRequirementsPage } from './FundingRequirementsPage';

export const FundingRequirementsUK = () => {
    return <FundingRequirementsPage />;
};
